import { gql, TypedDocumentNode } from "@apollo/client";

import { IntentChatConversation } from "types/generated";

type ChatConversationCreateData = {
  intentChatConversationCreate: Pick<IntentChatConversation, "id">;
};

export const CHAT_CONVERSATION_CREATE: TypedDocumentNode<ChatConversationCreateData> = gql`
  mutation ChatConversationCreate {
    intentChatConversationCreate {
      id
    }
  }
`;
